module.exports = __webpack_public_path__ + "static/media/Flowchart_CSE.9e7bff8e.jpg";